
import { IIconProps } from './add'

interface IIconFreeHand extends IIconProps {
    width?: string;
    height?: string;
    fill: string;
}

export const IconFreeHand = ({ style = {}, cy, fill, height = '20', width = '20' }: IIconFreeHand) => {
  return (
    <svg
    viewBox="0 0 12 13"
    xmlns="http://www.w3.org/2000/svg"
    fill= {fill}
    width={width}
    height={height}
    style={style}
    data-cy={`IconFreeHand${cy}`}>
        <path d="M10.735 5.42667L11.4417 4.72C11.9617 4.2 11.9617 3.35333 11.4417 2.83333L10.5017 1.89333C9.98167 1.37333 9.135 1.37333 8.615 1.89333L7.90833 2.6L10.735 5.42667ZM6.96167 3.54L0.835002 9.67333V12.5H3.66167L9.78833 6.37333L6.96167 3.54ZM10.835 10.1667C10.835 11.6267 9.14167 12.5 7.50167 12.5C7.135 12.5 6.835 12.2 6.835 11.8333C6.835 11.4667 7.135 11.1667 7.50167 11.1667C8.52833 11.1667 9.50167 10.68 9.50167 10.1667C9.50167 9.85333 9.18167 9.58667 8.68167 9.36667L9.66833 8.38C10.3817 8.8 10.835 9.36 10.835 10.1667ZM1.22167 7.4C0.575002 7.02667 0.168335 6.54 0.168335 5.83333C0.168335 4.63333 1.42833 4.08 2.54167 3.59333C3.22833 3.28667 4.16833 2.87333 4.16833 2.5C4.16833 2.22667 3.64833 1.83333 2.835 1.83333C1.995 1.83333 1.635 2.24 1.615 2.26C1.38167 2.53333 0.961668 2.56667 0.681668 2.34C0.408335 2.11333 0.355002 1.70667 0.581668 1.42C0.655002 1.32667 1.34167 0.5 2.835 0.5C4.32833 0.5 5.50167 1.38 5.50167 2.5C5.50167 3.74667 4.215 4.31333 3.075 4.81333C2.44833 5.08667 1.50167 5.5 1.50167 5.83333C1.50167 6.04 1.78833 6.23333 2.215 6.40667L1.22167 7.4Z" />
    </svg>
  )
}
